// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__21hbU","button":"styles_button__2yXhB","selectedButton":"styles_selectedButton__2T3n3"};